<template>
  <v-app>
    <v-container>
      <h2 class="mt-5 mb-10">よくあるご質問</h2>

      <div class="faq-panels">
        <div v-for="(faq, index) in faqs" :key="faq.question" class="faq-panel">
          <div class="faq-question" @click="toggleFaq(index)">
            <span class="question-text">{{ faq.question }}</span>
            <span class="triangle" :class="{ open: openedIndexes.includes(index) }">▶</span>
          </div>
          <div
            v-show="openedIndexes.includes(index)"
            class="faq-answer"
            v-html="`${faq.answer}`"
          ></div>
        </div>
      </div>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref } from "vue";

const openedIndexes = ref([]);

const toggleFaq = (index) => {
  const indexPosition = openedIndexes.value.indexOf(index);
  if (indexPosition > -1) {
    openedIndexes.value.splice(indexPosition, 1);
  } else {
    openedIndexes.value.push(index);
  }
};

const faqs = ref([
  {
    question: "いつくじの購入ができますか？",
    answer:
      "くじの購入は、各イベント期間中に可能です。<br>配信のスケジュールなどのアップデート情報は公式<a href='https://twitter.com/sukisukils'>X（旧twittter）</a>でも確認ができます。",
  },
  {
    question: "配信時間外に購入はできますか？",
    answer: "くじの購入は、各イベント期間中であれば配信時間外にも購入ができます。",
  },
  {
    question: "くじの注文は完了していますか？",
    answer:
      "通信エラーなどで、購入時に注文は確定している（注文確定メールが来ている）にも関わらず、<br>くじが引けなかった場合、注文後5分以内に自動でくじが引かれます。<br><a href='/orderhistory'>注文履歴</a>よりご確認をお願いします。<br>もし5分以上経っても注文履歴に当該の注文が表示されない場合は、お問い合わせよりご連絡ください。",
  },
  {
    question: "スーパーコメントとはなんですか？",
    answer: "スーパーコメントとはチャット欄で自分のメッセージを目立たせる有料コメント機能です。",
  },
  {
    question: "コメントを投稿したのですが、配信を閉じてしまいました。",
    answer:
      "コメント（スーパーコメントを含む）は、配信を開いた時点以降のコメントが表示されます。<br>つきまして配信を一度閉じてしまいますと以前のコメントは表示されません。配信者には問題なく届いておりますのでご安心ください。",
  },
  {
    question: "推奨ブラウザーを教えてください。",
    answer:
      "＜Windows PCおよびMac推奨ブラウザー＞<br>Google Chrome 最新版<br><br>＜Androidスマートフォン推奨ブラウザー＞<br>Google Chrome 最新版<br><br>＜Phone推奨ブラウザー＞<br>Google Chrome 最新版<br>Safari 最新版<br><br>となります。<br>※フィーチャーフォンは対応しておりません。予めご了承ください。",
  },
  {
    question: "販売数制限はありますか？",
    answer: "販売数制限はございません。",
  },
  {
    question: "発送日や運送会社の指定はできますか？",
    answer: "申し訳ありませんが、配送日の指定および運送会社の指定は承っておりません。",
  },
  {
    question: "複数回配送費用を支払ったのに1個口で届きました。",
    answer:
      "配送費用につきましては配送にかかる費用の他に、人員のコストや梱包費用や梱包材やそれにかかるも含まれているため、<br>ご購入個数に応じて20個毎にいただいております。<br>つきましては実際のお届け箱数につきましては、同梱でお送りする場合がございます。",
  },
  {
    question: "ランキングとはなんですか？",
    answer:
      "ランキングは、各イベント毎にランキングが表示される機能です。なお、ランキング順位の変動の要因等に関しての詳細については開示しておりません。予めご了承ください。",
  },
  {
    question: "機能追加要望やサービスについての要望があります。",
    answer:
      "ご要望についてはより良いサービスとするため随時募集しております。<a href='https://twitter.com/sukisukils'>公式X（旧twitter）</a>か<a href='https://sukisuki.live/inquiry'>お問い合わせフォーム</a>よりいただけますと幸いです。",
  },
  {
    question: "問い合わせ先は？",
    answer:
      "お問い合わせは<a href='https://sukisuki.live/inquiry'>こちらのお問い合わせフォーム</a>からお願いします。",
  },
]);
</script>

<style scoped>
.faq-panels {
  margin-top: 20px;
}
.faq-panel {
  margin-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}
.faq-question {
  display: flex;
  align-items: center;
  padding: 16px 0;
  cursor: pointer;
  user-select: none;
}
.question-text {
  flex: 1;
  text-align: left;
  line-height: 1.6;
}
.triangle {
  display: inline-block;
  font-size: 12px;
  color: #666;
  transition: transform 0.3s ease;
  margin-left: 8px;
}
.triangle.open {
  transform: rotate(90deg);
}
.faq-answer {
  line-height: 1.6;
  padding-top: 12px;
  padding-bottom: 16px;
  padding-left: 0;
  text-align: left;
}
.fcolor {
  color: rgb(237, 121, 149);
}
</style>
